import React, { useEffect, useState } from 'react';
import { onServiceWorkerUpdateReady, type ServiceWorkerUpdateHandle } from '../utils/swUpdate';

export default function ServiceWorkerUpdateBanner() {
  const [handle, setHandle] = useState<ServiceWorkerUpdateHandle | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    return onServiceWorkerUpdateReady((h) => {
      setHandle(() => h);
      setDismissed(false);
    });
  }, []);

  if (!handle || dismissed) return null;

  return (
    <div className="sw-update-banner" role="status" aria-live="polite">
      <div className="sw-update-banner__text">
        O versiune nouă a aplicației este disponibilă.
      </div>
      <div className="sw-update-banner__actions">
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => setDismissed(true)}>
          Mai târziu
        </button>
        <button type="button" className="btn btn-secondary btn-sm" onClick={handle.refreshToUpdate}>
          Refresh to update
        </button>
        <button type="button" className="btn btn-primary btn-sm" onClick={handle.updateNow}>
          Update now
        </button>
      </div>
    </div>
  );
}

